import { Pipe, PipeTransform, inject } from '@angular/core';
import { ContentService } from '../services/content.service';

@Pipe({
  name: 'content',
  standalone: true,
  pure: true
})
export class ContentPipe implements PipeTransform {
  private contentService: ContentService;

  constructor() {
    // Lazy inject so hybrid bootstrapping has time to finish
    this.contentService = inject(ContentService);
  }

  transform(contentId: string): string {
    return this.contentService.getContent(contentId);
  }
}
